import classNames from 'classnames'

import styles from './styles/InfoBanner.css'
import PropTypes from 'prop-types'

const InfoBanner = ({ className = '', children, show = true, setShow, state = 'info' }) => {
  return (
    show && (
      <div className={classNames(styles.infoContainer, styles[state], className)}>
        <div className={styles.message}>
          {state === 'error' && (
            <img
              className={styles.warningIcon}
              alt='warning'
              src={`${CONFIG.assetsBaseURL}/images/icons/warning.svg`}
            />
          )}
          {children}
        </div>
        {setShow && (
          <span className={styles.dismiss} onClick={() => setShow(false)}>
            <i className='icon icon-x' />
          </span>
        )}
      </div>
    )
  )
}

InfoBanner.propTypes = {
  setShow: PropTypes.func,
  show: PropTypes.bool,
  state: PropTypes.oneOf(['info', 'warning', 'error', 'success'])
}

export default InfoBanner
